import { StyleSheet } from 'aphrodite';

const styles = StyleSheet.create({
    buttonText: {
        color: '#00c8ff',
        font: 'inherit',
        fontFamily: 'Circular, -apple-system, BlinkMacSystemFont, Roboto, Helvetica Neue, sans-serif',
        textDecoration: 'none',
        appearance: 'none',
        background: 'transparent',
        border: '0px',
        cursor: 'pointer',
        margin: '0px',
        padding: '0px',
        textAlign: 'left',
        userSelect: 'auto',
        outline: 'none'
    },
    childContainer_hidden: {
        transform: 'translateY(-24px)',
        opacity: 0
    },
    childContainer_opening: {
        transition: '-ms-transform 304ms ease-out, -webkit-transform 304ms ease-out, transform ' +
                '304ms ease-out, opacity 304ms ease-out',
        transform: 'translateY(0px)',
        opacity: 1
    },
    childContainer_shown: {
        transform: 'translateY(0px)',
        opacity: 1
    },
    childContainer_closing: {
        transition: '-ms-transform 304ms ease-out, -webkit-transform 304ms ease-out, transform ' +
                '304ms ease-out, opacity 304ms ease-out',
        transform: 'translateY(-24px)',
        opacity: 0
    },
    clearfix: {
        clear: 'both'
    },
    container: {
        border: 'none',
        margin: '0px',
        padding: '0px'
    },
    containerOverflowHidden: {
        overflow: 'hidden'
    },
    containerTable: {
        display: 'table'
    },
    containerTableChild: {
        display: 'table-cell'
    },
    row: {
        marginLeft: '-8px',
        marginRight: '-8px',
        ':before': {
            content: '" "',
            display: 'table'
        },
        ':after': {
            content: '" "',
            display: 'table',
            clear: 'both'
        }
    },
    rowCondensed: {
        marginLeft: '-12px',
        marginRight: '-12px'
    },
    table: {
        display: 'table'
    },
    text: {
        color: '#484848',
        fontFamily: 'Circular, -apple-system, BlinkMacSystemFont, Roboto, Helvetica Neue, sans-serif',
        margin: '0px',
        wordWrap: 'break-word',
        fontSize: '19px',
        lineHeight: '24px',
        letterSpacing: undefined,
        paddingTop: '0px',
        paddingBottom: '0px',
        display: 'inline'
    },
    textExtra: {
        color: '#484848',
        fontFamily: 'Circular, -apple-system, BlinkMacSystemFont, Roboto, Helvetica Neue, sans-serif',
        margin: '0px',
        wordWrap: 'break-word',
        fontSize: '15px',
        lineHeight: '18px',
        letterSpacing: '0.2px',
        paddingTop: '0px',
        paddingBottom: '0px'
    },
    verticallyAlignMiddle: {
        verticalAlign: 'middle'
    },
    visuallyHidden: {
        position: 'absolute',
        display: 'block',
        border: '0px',
        margin: '-1px',
        padding: '0px',
        height: '1px',
        width: '1px',
        clip: 'rect(0, 0, 0, 0)',
        overflow: 'hidden'
    }
});

export default styles;



// WEBPACK FOOTER //
// ./src/pages/Search/Main/FilterBar/FilterGroupCollection/Panels/PanelLarge/Fieldset/styles.js